import React from 'react';
import Layout from '@/Shared/Layout';
import { useForm, usePage } from '@inertiajs/inertia-react';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/TextInput';
import CustomCheckbox from '@/Shared/CustomCheckbox';
import ImageInput from '@/Shared/ImageInput';
import { useDispatch } from 'react-redux';
import { openModal } from '@/Store/Slices/ModalSlice';

const Index = () => {
  const dispatch = useDispatch();
  const { main_settings } = usePage().props;
  const { data, setData, errors, post, processing } = useForm({
    show_accept_cookie_modal: main_settings.show_accept_cookie_modal || '',
    main_application_title: main_settings.main_application_title || '',
    main_application_logo: false
  });


  function handleSubmit(e) {
    e.preventDefault();
    post(route('main-settings.update', main_settings.id).url());
  }

  const showLogo = (src) => {
    dispatch(openModal({
      modalType: 'show-image',
      modalProps: {
        src: data.main_application_logo ? URL.createObjectURL(data.main_application_logo) : src,
      }
    }))
  }

  return (
    <div>
      <h1 className='mb-8 text-3xl font-bold'>
        Main Settings
      </h1>

      <div className='max-w-3xl overflow-hidden bg-white rounded shadow'>
        <form onSubmit={handleSubmit}>
          <div className='flex flex-wrap p-8 -mb-8 -mr-6'>
            <div className='w-full'>
              <TextInput
                className='w-full pb-8 pr-6 lg:w-1/2'
                label='Title'
                name='main_application_title'
                type='text'
                errors={errors.main_application_title}
                value={data.main_application_title}
                onChange={e => setData('main_application_title', e.target.value)}
              />
            </div>


            <ImageInput
              className='w-full pb-8 pr-6 lg:w-1/2'
              label='Logo'
              name='main_application_logo'
              errors={errors.main_application_logo}
              value={data.main_application_logo}
              onChange={main_application_logo => setData('main_application_logo', main_application_logo)}
            />

            <div className='w-full pb-8 pr-6 lg:w-1/2 flex items-center '>
              <a className='pt-4
               hover:decoration-indigo-600
                cursor-pointer
                 decoration-green-600
                 text-green-600
                 text-green-600
                 hover:text-indigo-600
                  underline
                   decoration-solid'
              onClick={() => showLogo(main_settings.main_application_logo)}>
                Show current logo
              </a>
            </div>

            <CustomCheckbox
              className='w-full pb-8 pr-6'
              label='Show Accept Cookie Modal'
              name='show_accept_cookie_modal'
              errors={errors.show_accept_cookie_modal}
              checked={data.show_accept_cookie_modal}
              onChange={e => setData('show_accept_cookie_modal', !!e.target.checked)}
            />
          </div>
          <div className='flex items-center justify-between px-8 py-4 bg-gray-100 border-t border-gray-200'>
            <LoadingButton
              loading={processing}
              type='submit'
              className='btn-default'
            >
              Change Settings
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Index.layout = page => <Layout title='Main Settings' children={page} />;
export default Index;
